var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoonnight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1360,
    height: 80,
    viewBox: "0 0 1360 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1360,
    height: 80,
    rx: 12,
    fill: "#286897"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_568_335",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1360,
    height: 80
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1360,
    height: 80,
    rx: 12,
    fill: "#286897"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_568_335)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1338,
    cy: 20,
    r: 30,
    fill: "#FFF8BA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonnight);
export default __webpack_public_path__ + "static/media/Moon night.ae0e6bbe1e0bfc883f3ba207396bf3b4.svg";
export { ForwardRef as ReactComponent };